import React from 'react';

interface ListGroupProps {
  as?: React.ElementType;
  className?: string;
  children?: React.ReactNode;
}

function ListGroupBase({ as: Tag = 'div', className = '', children }: ListGroupProps) {
  return <Tag className={`list-group flex flex-col rounded-lg border border-base-300 overflow-hidden ${className}`.trim()}>{children}</Tag>;
}

interface ItemProps {
  as?: React.ElementType;
  className?: string;
  children?: React.ReactNode;
  role?: string;
  'aria-label'?: string;
}

function ListGroupItem({ as: Tag = 'div', className = '', children, ...rest }: ItemProps) {
  return <Tag className={`list-group-item px-4 py-3 border-b border-base-300 last:border-b-0 ${className}`.trim()} {...rest}>{children}</Tag>;
}

const ListGroup = Object.assign(ListGroupBase, {
  Item: ListGroupItem,
});

export default ListGroup;
